import "./Services.css";
import arrow from "../../Images/Icons/arrow.png";
import { useNavigate } from "react-router-dom";
import backgroundImg from "../../Images/BackgroundImg/service.png";
import Headline from "../Headline/Headline";

const Services = () => {
    const LinkTo = useNavigate();
    const ServiceContent = [
        {
            id: 1,
            title: "Graphic Design",
            description:
                "Visual design across digital, print, and motion — including social media creatives, marketing assets, posters, banners, and brand collaterals — built for clarity and consistency."
        },
        {
            id: 2,
            title: "UI/UX Design",
            description:
                "User-focused interface and experience design for intuitive, efficient, and scalable web and mobile products."
        },
        {
            id: 3,
            title: "Logo Design & Branding",
            description:
                "Complete logo and brand identity systems designed for recognition, scalability, and long-term brand consistency across all platforms."
        },
        {
            id: 4,
            title: "Digital Marketing",
            description:
                "Design-driven digital marketing focused on brand visibility, audience engagement, and strategic positioning."
        }
    ];

    return (
        <>
            <div className="servicesSec">
                <div className="serviceSecHeadline">
                    <Headline text={"Service"}/>
                </div>

                <div className="serviceSecList">
                    {ServiceContent.map((service) =>
                        <div key={service.id}  className="serviceBox">
                            <div className="topService">
                                <div className="texts">
                                    <h2>{service.title}</h2>
                                    <span></span>
                                    <span></span>
                                </div>

                                <span className="forBigService"></span>
                                <span className="forBigService2"></span>
                            </div>
                            <div className="descService">
                                {service.description}
                            </div>
                            <div className="readMoreDesc">
                                <img src={backgroundImg} draggable="true" alt="" />
                                <div className="textsNarrow">
                                    <div onClick={() => LinkTo("/blog/graphic-design")} className="textDesc">
                                        <span>Read</span>
                                        <span>next</span>
                                    </div>
                                    <div className="arrowDesc">
                                        <img src={arrow} alt="" />
                                        <img src={arrow} alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </>
    )
}
export default Services;